import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const classes = `bg-amber-500 hover:bg-amber-600 text-stone-900 font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 text-lg md:text-xl ${fullWidth ? 'w-full' : ''} ${className}`;
  const checkoutUrl = 'https://claridadpluslab.com/cart/48762345488627:1';
  if (href && href.startsWith('#')) {
    return <a href={href} className={`${classes} inline-block text-center no-underline`} onClick={e => {
      e.preventDefault();
      const target = document.querySelector(href);
      target?.scrollIntoView({
        behavior: 'smooth'
      });
    }} data-id="element-48">
        {'Quiero Mi Gu\xEDa Ahora \u2014 $6.36 por tiempo limitado.'}
      </a>;
  }
  const handleCheckoutClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Memoria de Oro: Guía Anti-Olvidos',
        content_ids: ['48762345488627'],
        content_type: 'product',
        value: 6.36,
        currency: 'USD'
      });
    }
  };
  return <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className={`${classes} inline-block text-center no-underline`} onClick={handleCheckoutClick} data-id="element-49">
      {'Quiero Mi Gu\xEDa Ahora \u2014 $6.36 por tiempo limitado.'}
    </a>;
}